import FileSystem from './filesystem/filesystem'
import IndexedDbStorage from './storages/indexeddb'
import MemoryStorage from './storages/memory'

export {
  FileSystem,
  IndexedDbStorage,
  MemoryStorage
}

export default {
  FileSystem,
  IndexedDbStorage,
  MemoryStorage
}
